var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getKeys } from '../../adapters/utils';
import { SD_STATUS } from '../../consts';
import { CONTEXT_PROPS } from '../../types/ContextProps';
import { ITEM_TYPES } from '../../types/ItemTypes';
import { resolveItemTypeMultilingualUrl } from '../../utils/resolve-item-type-multilingual-url';
import { sanitizeUrl } from '../../utils/sanitize-url';
import { get } from '../../utils/get';
import { getStructuredData } from './adapter-utils';
export var IDs = {
    PAGE_NAME: 'page.name',
    PAGE_URL: 'page.url',
    FIRST_NAME: 'members-area-author-profile.first.name',
    LAST_NAME: 'members-area-author-profile.last.name',
    COMPANY: 'members-area-author-profile.company',
    JOB_TITLE: 'members-area-author-profile.job.title',
    NICKNAME: 'members-area-author-profile.nickname',
    MAIN_IMAGE: 'members-area-author-profile.main-image',
    TITLE: 'members-area-author-profile.title',
    DATE_CREATED: 'members-area-author-profile.date-created',
    SD_JSON_PERSON: 'members-area-author-profile.structured-data.person',
    SD_JSON_ARTICLES: 'members-area-author-profile.structured-data.articles',
    SD_JSON_IMAGES: 'members-area-author-profile.structured-data.images',
    DISABLE_IMAGES_SCHEMA: 'members-area-author-profile.images-schema.disable',
    SD_DISABLE_SCHEMA: 'members-area-author-profile.disable-schema',
    IMAGES_SD_STATUS: 'members-area-author-profile.structured-data.images-status',
};
var SchemaTypes = {
    MEMBERS_AREA_AUTHOR_PROFILE_IMAGES: 'members-area-author-profile-images',
    MEMBERS_AREA_AUTHOR_PROFILE_PAGE: 'members-area-author-profile-page',
};
var userVisible = [
    IDs.PAGE_NAME,
    IDs.PAGE_URL,
    IDs.FIRST_NAME,
    IDs.LAST_NAME,
    IDs.COMPANY,
    IDs.JOB_TITLE,
    IDs.NICKNAME,
    IDs.TITLE,
    IDs.MAIN_IMAGE,
];
var userVisibleSdOnly = [
    IDs.SD_JSON_IMAGES,
    IDs.DATE_CREATED,
    IDs.SD_JSON_ARTICLES,
    IDs.SD_JSON_PERSON,
];
var getSdStatus = function (item, data, schemaType) {
    // eslint-disable-next-line default-case
    switch (schemaType) {
        case SchemaTypes.MEMBERS_AREA_AUTHOR_PROFILE_IMAGES:
            return data[IDs.IMAGES_SD_STATUS];
        case SchemaTypes.MEMBERS_AREA_AUTHOR_PROFILE_PAGE:
            if (data[IDs.SD_JSON_ARTICLES].length === 0 ||
                data[IDs.NICKNAME] === '') {
                return SD_STATUS.DISABLED_DUE_TO_MISSING_INFO;
            }
            break;
    }
    return SD_STATUS.ENABLED;
};
export default {
    IDs: IDs,
    SchemaTypes: SchemaTypes,
    getData: function (item) {
        var _a, _b;
        var data = (_a = {},
            _a[IDs.PAGE_NAME] = get(item, "context.".concat(CONTEXT_PROPS.PAGE_NAME)),
            _a[IDs.PAGE_URL] = resolveItemTypeMultilingualUrl(ITEM_TYPES.MEMBERS_AREA_AUTHOR_PROFILE, item, sanitizeUrl(get(item, 'member.profile.profilePageUrl'))),
            _a[IDs.FIRST_NAME] = get(item, 'member.contact.firstName'),
            _a[IDs.LAST_NAME] = get(item, 'member.contact.lastName'),
            _a[IDs.COMPANY] = get(item, 'member.contact.company'),
            _a[IDs.JOB_TITLE] = get(item, 'member.contact.title'),
            _a[IDs.NICKNAME] = get(item, 'member.profile.nickname'),
            _a[IDs.TITLE] = get(item, 'member.profile.title'),
            _a[IDs.MAIN_IMAGE] = get(item, 'member.profile.photo.url'),
            _a[IDs.DATE_CREATED] = get(item, 'memberAbout.metadata.createdTimestamp'),
            _a);
        data = __assign(__assign({}, getStructuredData(IDs, data, item)), data);
        var profilePageSdStatus = getSdStatus(item, data, SchemaTypes.MEMBERS_AREA_AUTHOR_PROFILE_PAGE) !==
            SD_STATUS.ENABLED;
        return __assign(__assign(__assign({}, getStructuredData(IDs, data)), data), (_b = {}, _b[IDs.SD_DISABLE_SCHEMA] = profilePageSdStatus, _b));
    },
    getSdStatus: getSdStatus,
    getLegacySeoBlob: function () { },
    getSlug: function () { return ''; },
    updateItemDataWithSlug: function (item) { return item; },
    getKeys: function () { return getKeys(IDs, userVisible); },
    getSdKeys: function () { return getKeys(IDs, userVisibleSdOnly); },
};
